<template>
    <div id="header-right" class="header-left-side">
        <!-- <md-button
            v-tippy="{
                followCursor: true,
                placement: 'bottom-end',
                theme: isDarkMode ? 'light-border' : 'google',
            }"
            :content="isDarkMode ? $t('message.nightModeOn') : $t('message.nightModeOff')"
            class="custom-button header-btn"
            @click="toggleDarkMode"
        >
            <md-icon :style="{ color: darkMode ? 'yellow' : 'black' }">wb_incandescent</md-icon>
        </md-button>-->
        <!--<div v-if="!isAdmin && settings.privateChatEnabled" style="position: relative">
            <md-button class="custom-button" data-v-step="3" @click="toggleChat()">
                <Chats />
            </md-button>
        </div>-->
        <SupsisButton ghost @click="() => (debugToolVisible = true)" v-if="debugMode"> Debug Mode </SupsisButton>
        <md-button
            v-if="!blockedConnection"
            id="email-icon-header"
            style="min-width: fit-content; cursor: pointer; display: flex"
            @click="() => this.$router.replace(`/mails?selected=My`)"
        >
            <md-icon :style="{ color: darkMode ? 'yellow' : 'black' }">mail</md-icon>
            <SupsisBadge
                :badge="allUnreadMailCounts"
                v-if="allUnreadMailCounts !== 0"
                :class-name="'email-unread-count'"
            />
        </md-button>

        <md-button
            id="supsis-copilot"
            class="custom-button header-btn btnCopilot"
            @click="$feature.beforeUseChatCopilot(activateCopilot)"
            v-if="CONFIG.FEATURES.HEYSUPSIS_ENABLED && isTicketPage()"
        >
            <img src="/static/img/copilot.png" />
        </md-button>

        <TodayEvent v-if="!blockedConnection" />
        <!-- Show Intro Start-->
        <a-popover
            v-if="!blockedConnection"
            id="popoverHelpMenu"
            v-model="popovers.isHelpMenuPopoverOpen"
            data-v-step="4"
            placement="bottom"
            title=""
            trigger="click"
        >
            <template slot="content">
                <div id="popoverHelpMenuOpened">
                    <!-- <div v-if="!isAdmin" class="d-flex flex-row" style="display:none">
                        <div class="justify-content-start">
                            <show-intro />
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click="showIntro">
                            {{ $t("message.showIntro") }}
                        </div>
                    </div> -->
                    <!--                    <div v-if="!isAdmin" class="d-flex flex-row mt-3">-->
                    <!--                        <div class="justify-content-start">-->
                    <!--                            <color-meaning />-->
                    <!--                        </div>-->
                    <!--                        <div-->
                    <!--                            class="justify-content-end pl-3 popoverFont cursorPointer"-->
                    <!--                            @click="toggleChatColorModal(true)"-->
                    <!--                        >-->
                    <!--                            {{ $t("message.showChatColorMeaning") }}-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div v-if="!isAdmin" class="d-flex flex-row mt-3">
                        <div class="justify-content-start">
                            <keyboard />
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click="toggleKeyboardShotcutModal(true)"
                        >
                            {{ $t("message.keyboardShortcuts") }}
                        </div>
                    </div>
                    <div
                        class="pt-2 popoverFont justify-content-end popoverFont cursorPointer"
                        @click="showModal"
                        style="display: inline-flex; align-items: center; cursor: pointer"
                    >
                        <a-icon type="file-pdf" class="mr-3" style="font-size: 18px; color: #48b6e7" />
                        <div style="font-size: 14px">{{ $t("message.supsisDocument") }}</div>
                    </div>
                    <div v-if="!isAdmin" class="d-flex flex-row" style="margin-top: 10px; margin-bottom: -10px">
                        <div class="justify-content-start">
                            <NewIcon />
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click="openNewsModal">
                            {{ $t("message.news") }}
                        </div>
                        <NewsModal ref="newsModal" />
                    </div>
                    <div class="d-flex flex-row mt-3 mb-2">
                        <div class="justify-content-start">
                            <md-icon
                                style="
                                    color: red;
                                    width: 20px !important;
                                    min-width: 20px !important;
                                    height: 20px !important;
                                    font-size: 20px !important;
                                "
                                >support
                            </md-icon>
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click="integrationInstruction">
                            {{ $t("message.notIntegrated") }}
                        </div>
                    </div>
                    <div
                        :class="{
                            'd-flex flex-row mt-3': !isAdmin,
                            'd-flex flex-row': isAdmin,
                        }"
                    >
                        <div class="justify-content-start">
                            <span class="material-icons" style="font-size: 20px !important">help_center</span>
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click="connectSupportTeamRequest"
                        >
                            {{ $t("message.supportUs") }}
                        </div>
                    </div>
                    <div
                        :class="{
                            'd-flex flex-row mt-3': !isAdmin,
                            'd-flex flex-row': isAdmin,
                        }"
                    >
                        <div class="justify-content-start">
                            <md-icon :style="{ color: darkMode ? 'yellow' : 'black' }">report</md-icon>
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click="makeBugReport">
                            {{ $t("message.reportBug") }}
                        </div>
                    </div>
                    <div
                        :class="{
                            'd-flex flex-row mt-3': !isAdmin,
                            'd-flex flex-row': isAdmin,
                        }"
                    >
                        <div class="justify-content-start">
                            <span class="material-icons" style="font-size: 20px !important">apps</span>
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click="$router.push('/supsis-app')">
                            {{ $t("message.getApps") }}
                        </div>
                    </div>

                    <div
                        :class="{
                            'd-none flex-row mt-3': !isAdmin,
                            'd-none flex-row': isAdmin,
                        }"
                    >
                        <div class="justify-content-start">
                            <span class="material-icons" style="font-size: 20px !important">help_center</span>
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click="openPDF()">
                            {{ $t("message.help") }}
                        </div>
                    </div>
                    <AnnouncementNotifications />
                    <div
                        :class="{
                            'd-flex flex-row mt-2': !isAdmin,
                            'd-flex flex-row': isAdmin,
                        }"
                    >
                        <div class="justify-content-start">
                            <span class="material-icons" style="font-size: 20px !important">done</span>
                        </div>
                        <div class="justify-content-end pl-3 popoverFont">SUPSIS {{ version.versionStr }}</div>
                    </div>
                </div>
            </template>

            <md-button class="custom-button" :class="{ infoLight: unreadAnnouncements }">
                <a-badge color="#F64E60" v-if="unreadAnnouncements">
                    <Question></Question>
                </a-badge>
                <Question v-else></Question>
            </md-button>
        </a-popover>
        <!-- Show Intro Start-->

        <!-- Settings Popover Start-->
        <!--<div>
            <a-popover
                v-if="!blockedConnection"
                id="settingsMenu"
                v-model="popovers.isSettingPopoverOpen"
                data-v-step="5"
                placement="bottom"
                title=""
                trigger="click"
            >
                <template slot="content">
                    <div v-if="!isOpenLang" class="header-right-general-settings">
                        <div class="d-flex flex-row" style="align-items: center" @click="isOpenLang = !isOpenLang">
                            <div class="justify-content-start">
                                <country-flag
                                    :class="{
                                        selected: language.code === $i18n.locale,
                                    }"
                                    :country="
                                        language.code === 'en' ? 'us' : language.code === 'ar' ? 'sa' : language.code
                                    "
                                />
                            </div>
                            <div class="justify-content-end pl-3 cursorPointer popoverFont">
                                {{ $t("message.changeLang") }}
                            </div>
                        </div>
                        <div class="d-flex flex-row" v-if="!isAdmin">
                            <div class="justify-content-start">
                                <UserName />
                            </div>
                            <div
                                class="justify-content-end pl-3 popoverFont cursorPointer"
                                @click="() => setModalVisible(true, 'InSetting')"
                            >
                                <a-modal
                                    v-if="isVisibleRepresentativeModalInSetting"
                                    class="representativeSettings"
                                    :destroyOnClose="true"
                                    :footer="null"
                                    :title="$t('message.represantativeSettings')"
                                    :visible="modalVisible"
                                    :width="700"
                                    style="top: 20px"
                                    @cancel="() => setModalVisible(false)"
                                >
                                    <RepresentativeSettings />
                                </a-modal>
                                {{ $t("message.represantativeSettings") }}
                            </div>
                        </div>
                        <div>
                            <div class="pt-2 popoverFont">
                                {{ $t("message.fontSizeSetting") }}
                            </div>
                        </div>
                        <div>
                            <div>
                                <a-slider
                                    :max="zoomMaxRangeBound"
                                    :min="zoomMinRangeBound"
                                    :step="5"
                                    :value="zoomValue"
                                    @change="(value) => (this.zoomValue = value)"
                                />
                            </div>
                        </div>
                        <div class="d-flex flex-row">
                            <div class="justify-content-start">
                                <a
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :content="offlineMode ? $t('message.visitorScreen') : $t('message.visitorScreen')"
                                    :href="visitorScreenUrl"
                                    :style="{
                                        color: isDarkMode ? '#fff' : '#000',
                                    }"
                                    class=""
                                    target="_blank"
                                >
                                    <md-icon style="color: #369afe">preview</md-icon>
                                    {{ $t("message.visitorScreen") }}
                                </a>
                            </div>
                        </div>
                        <div class="d-flex flex-row switch-input" v-if="!isAdmin">
                            <div class="justify-content-start">
                                <a-switch v-model="shortcutReminderEnabled"></a-switch>
                                {{ shortcutReminder ? $t("message.showHint") : $t("message.dontShowHint") }}
                            </div>
                        </div>
                        <div class="d-flex flex-row switch-input dark-mode" v-if="!isAdmin">
                            <div class="justify-content-start">
                                <a-switch :value="isDarkMode" @change="toggleDarkMode">
                                    <div class="material-icons" slot="checkedChildren">dark_mode</div>
                                    <div class="material-icons" slot="unCheckedChildren">light_mode</div>
                                </a-switch>
                                {{ isDarkMode ? "Dark Mode" : "Light Mode" }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="langSetting">
                        <div
                            v-for="(language, index) in languages"
                            :key="'lang-' + index"
                            class="d-flex flex-row"
                            style="align-items: center; border-top: 1px solid #eef0f8"
                            @click="setCurrentLanguage(language.code)"
                        >
                            <div class="justify-content-start">
                                <country-flag
                                    :class="{
                                        selected: language.code === $i18n.locale,
                                    }"
                                    :country="
                                        language.code === 'en' ? 'us' : language.code === 'ar' ? 'sa' : language.code
                                    "
                                />
                            </div>
                            <div class="justify-content-end pl-3 cursorPointer popoverFont">
                                {{ language.name }}
                            </div>
                        </div>
                    </div>
                    <template>
                        <div>
                            <a-modal
                                :visible.sync="visible"
                                :cancel-text="null"
                                @ok="handleOk"
                                :width="1150"
                                :footer="false"
                                :footer-hide="true"
                                class="custom-modal"
                                v-on:cancel="visible = false"
                            >
                                <div style="height: 700px">
                                    <iframe
                                        style="width: 100%; height: 100%; border: none"
                                        src="https://doc.supsis.live/"
                                    ></iframe>
                                </div>
                            </a-modal>
                        </div>
                    </template>
                </template>
                <md-button class="custom-button">
                    <Settings />
                </md-button>
            </a-popover>
        </div>-->

        <div id="notifications">
            <a-popover
                v-if="!blockedConnection"
                v-model="popovers.notifications"
                placement="bottomRight"
                trigger="click"
                :overlayClassName="'no-padding notification-popover'"
            >
                <template slot="content" class="zero-padding p-0">
                    <NotificationPanel v-if="popovers.notifications" />
                </template>

                <md-button class="custom-button notification">
                    <SupsisBadge
                        :badge="unreadNotificationCount.toString()"
                        v-if="unreadNotificationCount !== 0"
                        :class-name="'activty-undread-count'"
                    />
                    <i class="material-icons">notifications</i>
                </md-button>
            </a-popover>
        </div>

        <!-- Settings Popover End Div-->
       <!-- <div class="header-selection-item" style="padding: 0; margin-left: 8px">
            <a-popover
                id="profileMenu"
                v-model="popovers.isProfileMenuPopoverOpen"
                data-v-step="6"
                placement="bottomLeft"
                title=""
                trigger="click"
            >
                <template slot="content">
                    <div v-if="user" class="d-flex flex-row">
                        <div class="justify-content-start">
                            <online />
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click.prevent="setStatus('Online')"
                        >
                            {{ $t("message.online") }}
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3">
                        <div class="justify-content-start">
                            <away />
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click.prevent="setStatus('Away')"
                        >
                            {{ $t("message.beRightBack") }}
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3">
                        <div class="justify-content-start">
                            <busy />
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click.prevent="setStatus('Busy')"
                        >
                            {{ $t("message.busy") }}
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3">
                        <div class="justify-content-start">
                            <offline />
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click.prevent="setStatus('Offline')"
                        >
                            {{ $t("message.offline") }}
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3" v-if="!isAdmin && !blockedConnection">
                        <div class="justify-content-start">
                            <UserName />
                        </div>
                        <div
                            class="justify-content-end pl-3 popoverFont cursorPointer"
                            @click="() => setModalVisible(true, 'InExitMenu')"
                        >
                            <a-modal
                                v-if="isVisibleRepresentativeModalInExitMenu"
                                class="representativeSettings"
                                :destroyOnClose="true"
                                :footer="null"
                                :title="$t('message.represantativeSettings')"
                                :visible="modalVisible"
                                style="top: 20px"
                                @cancel="() => setModalVisible(false)"
                                :width="700"
                            >
                                <RepresentativeSettings />
                            </a-modal>
                            {{ $t("message.represantativeSettings") }}
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-3">
                        <div class="justify-content-start">
                            <logout />
                        </div>
                        <div class="justify-content-end pl-3 popoverFont cursorPointer" @click.prevent="logout">
                            {{ $t("message.logout") }}
                        </div>
                    </div>
                </template>

                <a v-if="user">
                    <div class="avatarSection">
                        <span style="margin-right: 10px">
                            <strong>{{ user.name.charAt(0).toUpperCase() + nameSorter(user.name.slice(1)) }}</strong>
                        </span>
                        <div :class="user.status.toLowerCase()" class="avatar">
                            <a-avatar
                                v-if="!user.gravatar && !gravatar"
                                :size="24"
                                icon="user"
                                :username="user.name"
                                class="avatar"
                                :round="false"
                                :background-color="''"
                            ></a-avatar>
                            <img
                                v-else-if="user.gravatar || gravatar"
                                :src="user.gravatar || gravatar"
                                :alt="user.name"
                            />
                            <span v-else>{{ user.name.substr(0, 1).toUpperCase() }}</span>
                        </div>
                    </div>
                </a>
            </a-popover>
        </div>-->

        <div class="header-selection-item">
            <b-dropdown v-if="adminUser" id="user-dropdown" :text="adminUser.email" class="h-100" right>
                <template slot="button-content">
                    <img alt="Kullanıcı resmi" class="rounded-circle mx-1" src="https://placeimg.com/30/30/people" />
                    <small>{{ adminUser.name }}</small>
                </template>
                <b-dropdown-item class="mt-2" @click.prevent="logout">
                    <font-awesome-icon class="mr-2" icon="sign-out-alt" />
                    {{ $t("message.logout") }}
                </b-dropdown-item>
            </b-dropdown>
            <a-modal
                id="conversation-color-help2"
                :footer="null"
                :title="$t('message.chatColorMeanings')"
                :visible="chatColorModalVisible"
                @cancel="toggleChatColorModal(false)"
                @ok="toggleChatColorModal(false)"
            >
                <ConversationColorHelp />
            </a-modal>
            <a-modal
                id="ShortcutModal"
                :footer="null"
                :title="$t('message.keyboardShortcuts')"
                :visible="keyboardShortCutsModalVisible"
                @cancel="toggleKeyboardShotcutModal(false)"
            >
                <KeyboardShortcuts />
            </a-modal>
        </div>
        <a-modal v-model="debugToolVisible" title="Debug Tool" class="debug-tool-modal-wrapper" :footer="null">
            <DebugTool />
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCheckCircle,
    faClock,
    faMinusCircle,
    faPowerOff,
    faSignOutAlt,
    faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import SYSTEM_PUBSUB, { publishMessage, SystemMessageTypes } from "../utils/systemPubSub";
import { log2 } from "../utils/log2";
import moment from "moment";
import { sendSocketMessage } from "../utils/socketStream";
import RepresentativeSettings from "./RepresentativeSettings";
import * as _ from "lodash";
import version from "../utils/version";
import { onNewVersionReceived } from "../utils/utils";
import Chats from "../components/svg/Chats";
import Avatar from "vue-avatar";
import ConversationColorHelp from "./ConversationColorHelp";
import KeyboardShortcuts from "./KeyboardShortcuts";
import Version from "../components/svg/Version";
import ColorMeaning from "../components/svg/ColorMeaning";
import ShowIntro from "../components/svg/ShowIntro";
import Keyboard from "../components/svg/Keyboard";
import Online from "../components/svg/Online";
import Away from "../components/svg/Away";
import Busy from "../components/svg/Busy";
import Offline from "../components/svg/Offline";
import Logout from "../components/svg/Logout";
import SocketConnect from "./svg/SocketConnect";
import CountryFlag from "vue-country-flag";
import UserName from "../components/svg/UserName";
import Vue from "vue";
import Question from "../components/svg/Question";
import Settings from "../components/svg/Settings";
import { WEB_PUSH_NOTIFICATION_SERVICE } from "../push-notification/subscribe";
import AnnouncementNotifications from "./AnnouncementNotifications";
import NewsModal from "./common/NewsModal.vue";
import NewIcon from "./svg/NewIcon.vue";
import NotificationPanel from "../views/Pages/Notification/NotificationPanel.vue";
import SupsisBadge from "./common/SupsisBadge.vue";
import TodayEvent from "../views/Pages/Calendar/Component/TodayEvent.vue";
import CONFIG from "../config/config";
import SupsisButton from "../views/Pages/Settings/components/SupsisButton.vue";
import DebugTool from "./DebugTool.vue";
import WhatsappDebugTool from "../views/Pages/Whatsapp/components/WhatsappDebugTool.vue";

library.add(faCheckCircle, faClock, faMinusCircle, faPowerOff, faUserCog, faSignOutAlt);
const log = log2("HeaderRight");
Vue.component("country-flag", CountryFlag);

export default {
    name: "HeaderRight",
    components: {
        WhatsappDebugTool,
        TodayEvent,
        NotificationPanel,
        NewIcon,
        AnnouncementNotifications,
        RepresentativeSettings,
        Avatar,
        KeyboardShortcuts,
        Chats,
        ConversationColorHelp,
        Question,
        Settings,
        Version,
        ShowIntro,
        Keyboard,
        Online,
        Away,
        Busy,
        Offline,
        UserName,
        Logout,
        SocketConnect,
        ColorMeaning,
        NewsModal,
        SupsisBadge,
        SupsisButton,
        DebugTool,
    },
    data() {
        return {
            gravatar: null,
            visible: false,
            renderCount: 0,
            chatColorModalVisible: false,
            keyboardShortCutsModalVisible: false,
            zoomMaxRangeBound: 125,
            zoomMinRangeBound: 75,
            zoomValue: 100,
            modalVisible: false,
            version,
            newVersionAvailable: false,
            volume: -1,
            isOpenLang: false,
            isLiveSupportActive: false,
            customerDomainsFetched: false,
            isVisibleRepresentativeModalInSetting: true,
            isVisibleRepresentativeModalInExitMenu: true,
            CONFIG,
            debugToolVisible: false,
        };
    },
    computed: {
        ...mapState({
            blockedConnection: (state) => state.app.blockedConnection,
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
            isAdmin: (state) => state.auth.adminUser != null,
            menu: (state) => state.layout.menu,
            shortcutReminder: (state) => state.app.shortcutReminder,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            language: (state) => state.language.language,
            zoom: (state) => state.layout.zoom,
            settings: (state) => state.setting.settings,
            fakeMode: (state) => state.app.fakeMode,
            socketConnected: (state) => state.socketStatus.socket_connected,
            offlineMode: (state) => state.setting.offlineMode,
            debugMode: (state) => state.app.debugMode,
            socket: (state) => state.socketStatus.current_socket,
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
            customerDomains: (state) => state.visitor.customerDomains,
            popovers: (state) => state.app.headerPopoverStatus,
            announcements: (state) => state.announcement.announcements,
            unreadNotificationCount: (state) => state.app.unreadNotificationCount,
            allUnreadMailCounts: (state) => state.mail.allUnreadMailCounts,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            unreadAnnouncements: "announcement/unreadAnnouncements",
        }),
        darkMode: {
            set(value) {
                this.updateDarkMode(value);
            },
            get() {
                return this.isDarkMode;
            },
        },
        shortcutReminderEnabled: {
            set(value) {
                this.setShortcutReminder(value);
            },
            get() {
                return this.shortcutReminder;
            },
        },
    },
    methods: {
        isTicketPage() {
            return this.$route?.path?.includes("ticket") || false;
        },
        showModal() {
            this.visible = true;
            this.popovers.isSettingPopoverOpen = false;
        },
        handleOk(e) {
            this.visible = false;
        },
        ...mapActions({
            setUserStatus: "auth/setStatus",
            doLogout: "auth/logout",
            setLanguage: "language/setLanguage",
            changeZoom: "layout/changeZoom",
            refreshAuthUser: "auth/refreshAuthUser",
            getUsers: "user/getUsers",
            getUser: "user/getUser",
            updateUser: "user/updateUser",
            updateDarkMode: "user/updateDarkMode",
            togglePrivateChatVisibleState: "app/togglePrivateChatVisibleState",
            setChatFakeMode: "app/setChatFakeMode",
            getCustomerDomains: "visitor/getCustomerDomains",
            setShortcutReminder: "app/setShortcutReminder",
            getLastAnnouncements: "announcement/getLastAnnouncements",
            setNotificationsStatus: "app/setNotificationsStatus",
        }),
        makeBugReport() {
            const capture = async () => {
                const canvas = document.createElement("canvas");
                try {
                    const stream = await navigator.mediaDevices.getDisplayMedia({
                        video: { mediaSource: "screen" },
                    });
                    // get correct video track
                    const track = stream.getVideoTracks()[0];
                    const imageCapture = new ImageCapture(track);
                    // take first frame only
                    setTimeout(async () => {
                        const bitmap = await imageCapture.grabFrame();
                        track.stop();
                        canvas.width = bitmap.width;
                        canvas.height = bitmap.height;
                        const context = canvas.getContext("2d");
                        context.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height);
                        this.errorFileURl = canvas.toDataURL();
                        this.errorModalVisible = true;
                    }, 1000);
                } catch (err) {
                    console.error("Error: " + err);
                }
            };
            capture();
        },
        activateCopilot() {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.ACTIVE_VOICE_ASSISTANT, {});
        },
        updateVolume: _.debounce(async function (volume, showNotification = true) {
            log.debug("update volume called", this);
            this.user.audioAlertVolume = volume / 100;
            await this.updateUser({ ...this.user });
            await this.refreshAuthUser();
            if (showNotification)
                this.$toasted.show(this.$t("message.userVolumeUpdated"), {
                    duration: 3000,
                    position: "bottom-center",
                });
        }, 1000),
        updateZoom: _.debounce(function (value) {
            this.changeZoom(value);
        }, 1000),
        disconnectSocket() {
            if (this.debugMode && this.socketConnected) {
                this.socket.disconnect();
            }
        },
        toggleDarkMode() {
            this.updateDarkMode(!this.darkMode);
        },
        setModalVisible(modalVisible, option) {
            this.isVisibleRepresentativeModalInSetting = "InSetting" === option;
            this.isVisibleRepresentativeModalInExitMenu = "InExitMenu" === option;
            this.popovers.isRepresentativeSettingsPopoverOpen = modalVisible;
            this.modalVisible = modalVisible;
        },
        showIntro() {
            this.setChatFakeMode(true);
            setTimeout(() => {
                document.getElementById("contents").style.pointerEvents = "none";
                document.getElementById("sidebar").style.pointerEvents = "none";
            }, 100);
            publishMessage("showIntro", {});
        },
        toggleChatColorModal(visible) {
            log.debug("toggleChatColorModal called", visible);
            this.chatColorModalVisible = visible;
        },
        toggleKeyboardShotcutModal(visible) {
            log.debug("toggleKeyboardShotcutModal called", visible);
            this.keyboardShortCutsModalVisible = visible;
        },
        setCurrentLanguage(languageCode) {
            log.info("setCurrentLanguage", languageCode);
            this.setLanguage(languageCode);
            this.$i18n.locale = this.language.code;
            if (moment.locale() !== languageCode) moment.locale(languageCode);
            this.isOpenLang = !this.isOpenLang;
        },
        setStatus(status) {
            sendSocketMessage("user status-change", {
                userId: this.user._id,
                status: status,
                siteId: this.site._id,
            });

            this.setUserStatus(status);
        },
        integrationInstruction() {
            log("integrationInstruction", this.$router);
            this.$router.push("/install-code");
            const elem = document.getElementById("popoverHelpMenuOpened");
            if (elem && !elem.style.display) {
                document.getElementById("popoverHelpMenu").click();
            }
        },

        logout() {
            if (this.user) {
                WEB_PUSH_NOTIFICATION_SERVICE.unsubscribeFromAllTopic(this.site._id, this.user._id);
            }
            this.doLogout();
            this.$router.push("/login");
        },
        openPDF() {
            let pdfPath = "https://drive.google.com/file/d/1jLKdOUT_Y40zviEjsNw2oeuiNH4tz3i7/view";
            window.open(pdfPath, "_blank", "fullscreen=yes");
        },
        nameSorter(text) {
            if (text.length > 11) text = text.slice(0, 11) + "..";
            return text;
        },
        isSiteIntegrated() {
            return this.customerDomainsFetched && this.customerDomains.length;
        },
        reloadPage() {
            window.location.reload();
        },
        connectSupportTeamRequest() {
            log("connectSupportTeamRequest");
            if (document.getElementById("popoverHelpMenu")) {
                document.getElementById("popoverHelpMenu").click();
            }
            publishMessage(SystemMessageTypes.CONNECT_SUPPORT_TEAM, {});
        },
        openNewsModal() {
            this.$refs.newsModal.visible = true;
        },
    },
    mounted() {
        log("mounted zoom", this.zoom);
        this.zoomValue = this.zoom;
        /* this.darkMode.isActive = this.isDarkMode*/
        document.body.style.zoom = this.zoom + "%";
        this.$forceUpdate();
        //Get new version information If ther is new version ask to reload with button
        onNewVersionReceived.then((x) => {
            this.newVersionAvailable = true;
        });
        this.getCustomerDomains().then((x) => {
            this.customerDomainsFetched = true;
        });
        this.getLastAnnouncements({});
    },
    beforeDestroy() {},
    watch: {
        zoom(newValue) {
            log("zoom value changed", newValue);
            document.body.style.zoom = newValue + "%";
            this.$forceUpdate();
        },
        zoomValue(newValue, oldValue) {
            this.updateZoom(newValue);
        },
        volume(newValue, oldValue) {
            log.debug("volume change", { newValue, oldValue });
            if (newValue !== oldValue && oldValue !== -1) this.updateVolume(newValue, oldValue >= 0);
        },
        user(newUser) {
            log.debug("newUser", newUser);
            this.volume = newUser.audioAlertVolume ? newUser.audioAlertVolume * 100 : 0;
        },
        "popovers.isSettingPopoverOpen": function (newValue) {
            if (!newValue) {
                this.isOpenLang = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.header-right-general-settings {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 5px;
}

#header-right {
    .switch-input {
        &.dark-mode {
            .material-icons {
                font-size: 16px;
            }
        }
    }
}
</style>
<style lang="scss">
#ShortcutModal {
    .ant-modal {
        width: 65% !important;
    }
}

.representativeSettings {
    .ant-modal-body {
        padding: 24px 5px 24px 0px;
    }
}

.notification-popover {
    .ant-popover-inner-content {
        padding: 0px !important;
    }
}
</style>
<style lang="scss" scoped>
#header {
    padding-left: 0px;
    border-bottom: 1px solid var(--color-border-default);
    height: 45px;

    .custom-button {
        width: 35px;
        min-width: 35px;
        height: 35px;
        border-radius: 8px;
        margin: 8px;
        border: 1px solid var(--color-border-default);

        &.notification {
            position: relative;

            .notification-badge {
                position: absolute;
                top: 0px;
                right: -5px;
                width: 15px;
                height: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f64e60;
                color: white;
                border-radius: 15px;
                font-size: 10px;
            }
        }
    }

    .custom-version-btn {
        height: 35px;
        border-radius: 8px;
        margin: 8px;
        text-transform: capitalize !important;
        display: flex;
        align-items: center;
        flex-direction: row;
        color: #448aff;
        border: 1px solid var(--color-border-default);

        svg {
            display: flex;
            align-items: center;
            fill: #448aff;
            margin-right: 4px;
        }
    }

    .avatarSection {
        display: flex;
        align-items: center;

        span {
            font-family: Poppins;
            font-size: 13px;
            color: #b5b5c3;

            strong {
                font-family: Poppins;
                font-size: 13px;
                color: #7e8299;
            }
        }

        .avatar {
            border-radius: 8px;
            width: 35px;
            height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Poppins;
            font-size: 16px;
            overflow: hidden;

            &.online {
                color: #1bc5bd;
                background-color: #c9f7f5;
                border: 2px solid #1bc5bd;
            }

            &.offline {
                color: #f64e60;
                background-color: #fdbec5;
                border: 2px solid #f64e60;
            }

            &.away {
                color: #3699ff;
                background-color: #acd5ff;
                border: 2px solid #3699ff;
            }

            &.busy {
                color: #ffa829;
                background-color: #ffe6c1;
                border: 2px solid #ffa829;
            }

            img {
                border-radius: 7px;
                padding-top: 2px;
                padding-bottom: 2px;
            }

            .ant-avatar {
                background-color: transparent !important;
            }
        }
    }
}
</style>

<style>
.cursorPointer {
    cursor: pointer;
}

.cursorPointer:hover {
    font-weight: 600;
}

.popoverFont {
    font-family: Poppins;
    font-size: 14px;
    color: #181c32;
    font-weight: 300;
}
</style>
